export function DefaultHelmetHTML() {
  return null;
}
